(function () {
  const endpoint = 'https://good-elevation-ai.vercel.app/api/events';
  const sessionKey = 'goodElevationAnalyticsSession';

  function id() {
    return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }

  function sessionId() {
    let value = window.localStorage.getItem(sessionKey);
    if (!value) {
      value = id();
      window.localStorage.setItem(sessionKey, value);
    }
    return value;
  }

  function customerEmail() {
    try {
      return JSON.parse(window.localStorage.getItem('goodElevationCustomerProfile') || '{}').email || '';
    } catch (_) {
      return '';
    }
  }

  function track(event, metadata) {
    const payload = {
      event_id: id(),
      event,
      session_id: sessionId(),
      customer_email: customerEmail(),
      path: `${window.location.pathname}${window.location.search}`,
      metadata: metadata || {}
    };
    fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(() => {});
  }

  window.GoodElevationAnalytics = { track, sessionId };
}());
